module.exports = __webpack_public_path__ + "static/media/schedule.acce8940.jpg";